import Raven from '../Raven';

export const getSamedayDelivery = () => {
    return Raven.get('https://gcm6x1xdj5.execute-api.us-east-2.amazonaws.com/dev/api/getsameday')
}